export default class SkipLinks {
	constructor() {
		this.links = document.querySelectorAll(".skip-links a");
		this.events();
	}

	events() {
		this.links.forEach((link) => {
			link.addEventListener("click", () => {
				this.focusElement(link);
			});
		});
	}

	focusElement(element) {
		if (element) element.focus();
	}
}
